import { IReoccurringReport } from "api/interfaces/IReoccurringReport"

import Resource from "../Resource"

class ReportResource extends Resource<IReoccurringReport> {
  get resourcePath() { return "/api/reoccurring_reports" }
}

export default ReportResource
